<form [formGroup]="direccionGeograficaFormGroup" #direccionGeograficaForm="ngForm">
  <ng-container *ngIf="direccionGeograficaSet$ | async as direccionGeograficaSet">
    <div class="row" *ngIf="withCountryOption">
      <mat-form-field>
        <mat-label>País:</mat-label>
        <mat-select formControlName="pais_codigo" required (selectionChange)="onPaisSelect($event)">
          <mat-option *ngFor="let pais of direccionGeograficaSet.paises" [value]="pais.codigo">
            {{pais.nombre}}
          </mat-option>
        </mat-select>
        <mat-error *ngIf="direccionGeograficaFormGroup.get('pais_codigo')?.hasError('required')">
          Debe ingresar país
        </mat-error>
      </mat-form-field>
    </div>
    <div class="row" *ngIf="esUruguay">
      <mat-form-field class="col-xs-12 col-sm-6">
        <mat-label>Departamento:</mat-label>
        <mat-select formControlName="departamento_codigo" required (selectionChange)="onDepartamentoSelect($event)">
          <mat-option *ngFor="let departamento of direccionGeograficaSet.departamentos" [value]="departamento.codigo">
            {{departamento.nombre}}
          </mat-option>
        </mat-select>
        <mat-error *ngIf="direccionGeograficaFormGroup.get('departamento_codigo')?.hasError('required')">
          Debe ingresar departamento
        </mat-error>
      </mat-form-field>

      <mat-form-field class="col-xs-12 col-sm-6">
        <mat-label>Localidad:</mat-label>
        <mat-select formControlName="localidad_id" required (selectionChange)="onLocalidadSelect($event)">
          <mat-option *ngFor=" let localidad of localidadesFiltrada$ | async" [value]="localidad.id">
            {{localidad.nombre}}
          </mat-option>
        </mat-select>
        <mat-error *ngIf="direccionGeograficaFormGroup.get('localidad_id')?.hasError('required')">
          Debe ingresar localidad
        </mat-error>
      </mat-form-field>
    </div>
    <div class="row">
      <mat-form-field class="col-xs-12">
        <input matInput placeholder="Código postal:" formControlName="codigo_postal" type="number">
      </mat-form-field>
    </div>
    <div class="row">
      <mat-form-field class="col-xs-12">
        <input matInput placeholder="Dirección completa:" formControlName="direccion" type="text" required
          (keyup)="onDireccionKeyUp($event)">
        <!--<mat-autocomplete #auto="matAutocomplete" (optionSelected)="onDireccionSelect($event.option.value)">
                    <mat-option *ngFor=" let direccion of direccionGeograficaSet.direccionesGeograficasIDE"
                        [value]="direccion.address">
                        {{direccion.address}}
                    </mat-option>
                </mat-autocomplete> -->
        <mat-error *ngIf="direccionGeograficaFormGroup.get('direccion')?.hasError('required')">
          Debe ingresar dirección
        </mat-error>
      </mat-form-field>
      <!--<mat-hint id="hintspace">
                <fa-icon icon="info-circle"></fa-icon>
                <span id="smallerFont"> Seleccione una dirección del listado para ubicarse en el mapa </span>
            </mat-hint>-->
    </div>
    <ng-container>
      <div class="row">
        <mat-form-field>
          <mat-label>Seleccione una dirección del listado para ubicarse en el mapa:</mat-label>
          <mat-select (selectionChange)="onDireccionSelect($event.value)" [required]="true">
            <mat-option *ngFor=" let direccion of direccionGeograficaSet.direccionesGeograficasIDE"
              [value]="direccion.address">
              {{direccion.address}}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>
      <!-- Mensaje cuando no hay direcciones pero el usuario ya escribió -->
      <div class="info-message-box"
        *ngIf="direccionGeograficaFormGroup.get('direccion')?.value?.length >= 4 && 
                   (!direccionGeograficaSet?.direccionesGeograficasIDE || direccionGeograficaSet.direccionesGeograficasIDE.length === 0)">
        <mat-icon>info</mat-icon>
        <span>No se encontraron direcciones coincidentes. Puede seleccionar la ubicación manualmente en el mapa.</span>
      </div>
    </ng-container>
    <div class="row">
      <gis-map [positionInput]="position" (position)="onChangePosition($event)"></gis-map>

      <mat-error
        *ngIf="direccionGeograficaFormGroup.get('latitud')?.hasError('required') && (direccionGeograficaFormGroup.get('latitud')?.dirty || direccionGeograficaFormGroup.get('latitud')?.touched)">
        <span id="smallerFont"> Debe seleccionar la ubicación en el mapa </span>
      </mat-error>
    </div>
  </ng-container>
</form>